import { editPricingOfAccountEmailCampaign, getPricingOfAccountEmailCampaign } from "../types/account_campaign_pricing_email_types";

export const getPricingOfAccountEmailCampaignRequest = (payload, cb) => ({
  type: getPricingOfAccountEmailCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const getPricingOfAccountEmailCampaignSuccess = (payload) => ({
  type: getPricingOfAccountEmailCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_SUCCESS,
  payload,
});
export const getPricingOfAccountEmailCampaignError = (payload) => ({
  type: getPricingOfAccountEmailCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_ERROR,
  payload,
});

export const editPricingOfAccountEmailCampaignRequest = (payload, cb) => ({
  type: editPricingOfAccountEmailCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST,
  payload,
  cb,
});
export const editPricingOfAccountEmailCampaignSuccess = (payload) => ({
  type: editPricingOfAccountEmailCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_SUCCESS,
  payload,
});
export const editPricingOfAccountEmailCampaignError = (payload) => ({
  type: editPricingOfAccountEmailCampaign.EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_ERROR,
  payload,
});
